import { createAsyncAction } from 'react-redux-await-control';
import { backoffice } from '~/services';
import { handleErrors } from '~/common/utils/errorHandler';
import {
  CancellableInsuranceContract,
  InsuranceCancellationResponse,
  InsuranceContractType,
} from '~/typings/entities/Insurance';

export const getCancellableInsuranceContracts = createAsyncAction('GET_CANCELLABLE_INSURANCE_CONTRACTS', {
  saveResult: true,
  initialValue: [],
  context: {
    request: ({ personId }) => backoffice.get('/insurance/cancellable-contracts', { params: { personId } }),
    responseParser: ({ data }): CancellableInsuranceContract[] => data || [],
    errorParser: () => [],
    onRequestError: (err) => handleErrors(err, { defaultMessage: 'Erro ao buscar contratos canceláveis' }),
  },
});

type CancelInsuranceContractPayload = {
  contractId: number | string;
  contractType: InsuranceContractType;
  reasonId: number;
  reasonText?: string;
};

export const cancelInsuranceContract = createAsyncAction('CANCEL_INSURANCE_CONTRACT', {
  saveResult: true,
  initialValue: null,
  context: {
    request: (payload: CancelInsuranceContractPayload) => backoffice.post('/insurance/contracts/cancel', payload),
    responseParser: ({ data }): InsuranceCancellationResponse => data,
    onRequestError: (err) => handleErrors(err, { defaultMessage: 'Erro ao cancelar contrato de seguro' }),
  },
});
